import Component from './Component';
import Flickity from 'flickity';

export default class ImageVideoCarouselWithSummary extends Component {
    load() {
        this.initFlickity();

        super.load();
    }

    initFlickity() {
        const items = document.querySelectorAll('.image-video-carousel-with-summary__items');
        if (items) {
            Array.prototype.slice.call(items).map((el) => {
                const itemsFlickity = new Flickity(el, {
                    cellAlign: 'center',
                    contain: false,
                    pageDots: true,
                    prevNextButtons: true,
                    wrapAround: true,
                    imagesLoaded: true,
                    // lazyLoad: true,
                    on: {
                        ready: function () {
                        },
                        change: function (index) {
                        }
                    }
                });
            });
        }
    }
}
